import request from "../../util/axios-request";
import {v4 as uuidv4} from "uuid";
import moment from "moment";
import apolloClient from "../../graphql/utitl";
import gql from "graphql-tag";

// 生成二维码
export function generateQrcode(params) {
  const defaultParams = {
    msgType: 'getQRCode',
    msgID: uuidv4(),
    timestamp: moment(new Date()).valueOf(),
    ver: '1',
    /*cmd: '',
    deviceID: '',
    pageNo: '',
    agentID: ''*/
  }

  const mergedParams = {...defaultParams, ...params}
  return request({
    url: '/customer/zmxcl/entry',
    method: 'post',
    data: mergedParams
  })
}

// 查询门店
export function getPosByPosName(params) {
    return apolloClient.query({
      fetchPolicy: 'no-cache',
      query: gql`query queryPosInfo(
        $partnerId: String,
      ){
        # 方法名
        queryPosInfo
        # 参数 (全部可选)
        (
          posDTO: {
            minStarLevel: 1, # 最低星级 (double)
            maxStarLevel: 5, # 最高星级 (double)
            partnerId: $partnerId,
            page: 1,
            size: 2000
          }
        )

        # 返回字段
        {
          # 门店信息
          pos {
            id
            posId      # 门店编号
            partnerId  # 商户编号
            starLevel  # 星级 (double) (0-5)
            washerType # 洗车类型,0:智能，1:自助, 2:人工 3:充电桩
            name       # 门店名称
          }

          # 设备信息
          device {
            snOfPartnerId # 归属商户的设备序号
          }
        }

      }`,
      variables: params
    })
}



// WEBPACK FOOTER //
// ./src/api/axios/generate-qrcode.js